"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const pie_chart_svg_1 = __importDefault(require("assets/zero-state-images/pie-chart.svg"));
const utils_1 = require("utils/date/utils");
const utils_2 = require("utils/utils");
const transactionSelectors = __importStar(require("data/transactions/selectors"));
const selectors_1 = require("data/reports/selectors");
const QCurrency_1 = __importDefault(require("components/QCurrency"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const mui_1 = require("tss-react/mui");
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const helpers_1 = require("../helpers");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const isIe = require('is-iexplorer') || (0, utils_2.isOldEdge)(); // eslint-disable-line
// utility function to divvy an array into an array of smaller arrays of a specified length
const chunkify = (array, chunkSize) => Array(Math.ceil(array.length / chunkSize))
    .fill(null)
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize));
const PAYEES_PER_SECTION = 5;
const SECTIONS_PER_PAGE = 2;
const PAYEES_PER_PAGE = PAYEES_PER_SECTION * SECTIONS_PER_PAGE;
const PayeeCheckbox = ({ checked, classes, number = 1 }) => (<div className={checked ? classes.customCheckBoxChecked : classes.customCheckBox}>
    <span>{number}</span>
  </div>);
const PayeeCheckboxLabel = ({ payee, classes, selected, onClick }) => (<button onClick={onClick} className={(0, classnames_1.default)(classes.labelTextLayout, selected ? classes.labelTextSelected : classes.labelText, classes.btnStyle)} type="button">
    <QTip_1.default title={payee} wrapOnly offset={100} distance={20}>
      <Typography_1.default component="div" variant="body2" className={classes.payeeName}>{payee}</Typography_1.default>
    </QTip_1.default>
  </button>);
const Section = ({ datums, classes, clickHandler, selectedPayeeIndex }) => {
    if (datums) {
        return (<styles_1.SectionWrap>
        {datums.map((datum, i) => {
                const key = `datum-${i}`;
                const selected = selectedPayeeIndex === datum.index;
                return (<Fade_1.default key={key} appear in>
              <div className={classes.itemWrap}>
                <Checkbox_1.default className={classes.payeeCheckbox} icon={<PayeeCheckbox checked={false} classes={classes} number={datum.index + 1}/>} checkedIcon={<PayeeCheckbox checked classes={classes} number={datum.index + 1}/>} checked={selectedPayeeIndex === datum.index} onClick={(e) => clickHandler(e, datum.index, datum.payee)} disableRipple/>
                <PayeeCheckboxLabel onClick={(e) => clickHandler(e, datum.index, datum.payee)} payee={datum.payee} classes={classes} selected={selected}/>
                <AmountField_1.default variant="body2" value={Math.abs(Number(datum.amount))} className={selected ? classes.labelTextSelected : classes.labelText} currencySymbol={datum.currency} useAbsoluteValue omitCents/>
              </div>
            </Fade_1.default>);
            })}
      </styles_1.SectionWrap>);
    }
    return (<div> </div>);
};
const Page = ({ datums, classes, clickHandler, selectedPayeeIndex }) => {
    const sectionData = chunkify(datums, PAYEES_PER_SECTION);
    return (<styles_1.PageWrap>
      <Section datums={sectionData[0]} classes={classes} clickHandler={clickHandler} selectedPayeeIndex={selectedPayeeIndex}/>
    </styles_1.PageWrap>);
};
const SpendingByPayee = () => {
    var _a, _b, _c, _d;
    const { classes } = useStyles();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [selectedPayeeIndex, setSelectedPayeeIndex] = (0, react_1.useState)(null);
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const isLoading = (0, react_redux_1.useSelector)((state) => transactionSelectors.getLoadPending(state) || categories_1.categoriesSelectors.getLoadPending(state));
    const predefinedInterval = (0, utils_1.getPredefinedRange)({ value: 'MONTH_TO_TODAY' });
    const spendingByPayee = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIncomeSpendingReportForDisplay)(state, {
        dateRange: predefinedInterval,
        reportName: 'spending',
        chartType: 'pie',
        groupBy: 'payee',
    }));
    const payeeSpending = ((_d = (_c = (_b = (_a = spendingByPayee === null || spendingByPayee === void 0 ? void 0 : spendingByPayee.toObject()) === null || _a === void 0 ? void 0 : _a.chartData) === null || _b === void 0 ? void 0 : _b.totals) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.subgroups) || [];
    const navigateToSpendingByPayee = (e) => {
        e.stopPropagation();
        navigate('/reports/spending/by-payee/total');
    };
    const navigateToSpendingByPayeeWithPayee = (index) => {
        navigate(`/reports/spending/by-payee/total?selectPayee=${index}`);
    };
    const handleCheckboxClick = (e, index) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedPayeeIndex(index);
        setTimeout(() => navigateToSpendingByPayeeWithPayee(index), 0);
    };
    const dataIsNull = () => !payeeSpending || isLoading;
    const dataIsEmpty = () => !dataIsNull() && payeeSpending.length === 0;
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts);
    let spendingExcludingTransactions;
    let dataForRender;
    if (payeeSpending) {
        spendingExcludingTransactions = payeeSpending.map((o, i) => ({
            payee: o.groupKey,
            amount: -o.total,
            currency: o.currency,
            index: i,
        }));
        spendingExcludingTransactions.length = 5;
        dataForRender = chunkify(spendingExcludingTransactions, PAYEES_PER_PAGE);
    }
    return (<div className={classes.root} onClick={view === 'main' || view === 'empty' ? navigateToSpendingByPayee : noop_1.default} onKeyPress={view === 'main' || view === 'empty' ? navigateToSpendingByPayee : noop_1.default} style={{ cursor: (view === 'main' || view === 'empty') ? 'pointer' : 'auto' }} role="presentation">
      {view === 'loading' &&
            <LoadingView_1.default />}
      {view === 'zero' &&
            <ZeroStateView_1.default size="small" icon={pie_chart_svg_1.default} secondary="Sync your financial institutions to see your top payees"/>}
      {view === 'empty' &&
            <ZeroStateView_1.default onClick={navigateToSpendingByPayee} size="small" icon={pie_chart_svg_1.default} primary="No Spending" secondary={['It looks like you haven', <span key="quote">&rsquo;</span>, 't spent any money this month. ', <br key="br"/>, <br key="br2"/>, <span key="click" className={classes.link}>Click here</span>, ' to choose ', <br key="br3"/>, 'a different date range.']}/>}
      {view === 'main' &&
            <div style={{ height: '100%' }}>
        {dataForRender.map((data, index) => {
                    const key = `page-${index}`;
                    return (<Page datums={data} classes={classes} key={key} clickHandler={handleCheckboxClick} selectedPayeeIndex={selectedPayeeIndex}/>);
                })}
      </div>}
    </div>);
};
exports.default = (0, QCurrency_1.default)()(SpendingByPayee);
